import { PuxButton, PuxIcon } from "@phonero/pux-react"
import css from "./IconButton.module.scss"
import cx from "classnames"
import { CSSProperties } from "react"

export const IconButton = ({
  icon,
  title,
  onClick,
  disabled,
  fill,
  iconSize,
  iconColor,
  className,
  style,
  iconStyle,
  noSpaceAround,
}: {
  icon: any
  title?: string
  onClick?: (e: any) => void
  disabled?: boolean
  fill?: "solid" | "clear" | "outline" | "default" | undefined
  iconSize?: "extra-small" | "small" | "large" | undefined
  iconColor?: string
  className?: string
  style?: CSSProperties
  iconStyle?: CSSProperties
  /**This prop controls the padding and margin around the pux-button */
  noSpaceAround?: boolean
}) => {
  return (
    <PuxButton
      className={cx(css.panelActionButtonInner, className)}
      fill={fill ?? "solid"}
      color="primary"
      data-pux-icon="true"
      title={title}
      onClick={onClick}
      disabled={disabled}
      style={{
        zIndex: 20,
        padding: !!noSpaceAround ? 0 : undefined,
        margin: !!noSpaceAround ? 0 : undefined,
        ...style,
      }}
    >
      <PuxIcon
        className={css.panelActionFontSize}
        icon={icon}
        size={iconSize}
        slot="icon-only"
        color={iconColor ?? "primary"}
        style={iconStyle}
      />
    </PuxButton>
  )
}
